const routes = [
    {
        path: "/courseprerequisites",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "courseprerequisite_index"
        }
    }
];

export default routes;
